module.exports = __webpack_public_path__ + "static/media/cocoboBg.6c94d2ff.jpg";